import { Button, Container, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetRestaurant } from 'src/api/restaurant';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs/custom-breadcrumbs';
import Iconify from 'src/components/iconify';
import { RouterLink } from 'src/routes/components';
import SubscriptionEdit from 'src/sections/restaurant/subscription-edit';


// ----------------------------------------------------------------------

export default function SubscriptionAdd() {
    const { restaurantId } = useParams();

    const { restaurant } = useGetRestaurant(Number(restaurantId))
    const navigate = useNavigate()
    return (
        <>
            <Helmet>
                <title> Dashboard: Subscription Add</title>
            </Helmet>


            <Container maxWidth={false}>
                <Button
                    size='small'
                    variant='soft'
                    component={RouterLink}
                    onClick={() => navigate(-1)}
                    startIcon={<Iconify icon="eva:arrow-ios-back-fill" width={16} />}
                >
                    Back to Subscriptions List
                </Button>

                <CustomBreadcrumbs
                    heading='Create Subscription'
                    sx={{ mt: 2 }}
                    links={[
                        {},
                    ]}
                />
                <br />

                {restaurant?.name_en && <Typography
                    variant="h6"
                    sx={{ mb: 5, textAlign: 'center' }}
                >
                    {restaurant?.name_en}
                </Typography>}


                <SubscriptionEdit id={undefined} restaurantId={Number(restaurantId)} />
            </Container>

        </>
    );
}
